import { useEffect, useState } from 'react'

import { MOBILE_MEDIA_QUERY } from '@/constants/breakpoints'

/**
 * Tracks whether the viewport is at or below the mobile breakpoint
 * (see `MOBILE_MAX_WIDTH_PX`). Subscribes to viewport changes so consumers
 * re-render when the user crosses the breakpoint (resize, orientation change).
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window === 'undefined' ? false : window.matchMedia(MOBILE_MEDIA_QUERY).matches,
  )

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined
    }

    const mediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY)
    const handleChange = (event: MediaQueryListEvent) => setIsMobile(event.matches)

    mediaQueryList.addEventListener('change', handleChange)
    // Sync in case the viewport changed between the initial render and this effect.
    setIsMobile(mediaQueryList.matches)

    return () => mediaQueryList.removeEventListener('change', handleChange)
  }, [])

  return isMobile
}
